// Bubble Blast progress — persisted per-device so a player picks up where they
// left off, weapons and all.

const KEY = "su_bubble_v1";

export interface BubbleSave {
  level: number;
  score: number;
  wBomb: number;
  wMissile: number;
  wBallistic: number;
}

const blank: BubbleSave = { level: 1, score: 0, wBomb: 0, wMissile: 0, wBallistic: 0 };

export function loadBubble(): BubbleSave {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...blank };
    const p = JSON.parse(raw);
    return {
      level: Math.max(1, Math.floor(Number(p.level) || 1)),
      score: Math.max(0, Math.floor(Number(p.score) || 0)),
      wBomb: Math.max(0, Math.floor(Number(p.wBomb) || 0)),
      wMissile: Math.max(0, Math.floor(Number(p.wMissile) || 0)),
      wBallistic: Math.max(0, Math.floor(Number(p.wBallistic) || 0)),
    };
  } catch {
    return { ...blank };
  }
}

export function saveBubble(s: Partial<BubbleSave>) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...loadBubble(), ...s }));
  } catch { /* private mode — nothing to do */ }
}
